import { AxiosUtilsType, axiosGet, axiosPost } from './axiosUtils';
import './axiosInterceptor';

const SecurityConcernService = {
  async updateAgreement(): AxiosUtilsType {
    return await axiosPost(`securityConcern/updatePersonalSecurity`);
  },
  async checkAgreement(): AxiosUtilsType {
    return await axiosGet(`securityConcern/check`);
  },
};
export default SecurityConcernService;
